/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_LabelInputs */

const en_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default Background Color`)
};

const fr_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur de fond par défaut`)
};

const de_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-Hintergrundfarbe`)
};

const it_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore di sfondo predefinito`)
};

const ru_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет фона по умолчанию`)
};

const es_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de fondo predeterminado`)
};

const zh_cn2_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认背景颜色`)
};

const ja_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルトの背景色`)
};

const hi_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिफ़ॉल्ट पृष्ठभूमि रंग`)
};

const pt_pt2_options_display_default_background_color_label = /** @type {(inputs: Options_Display_Default_Background_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de fundo predefinida`)
};

/**
* | output |
* | --- |
* | "Default Background Color" |
*
* @param {Options_Display_Default_Background_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_label = /** @type {((inputs?: Options_Display_Default_Background_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_default_background_color_label(inputs)
	if (locale === "de") return de_options_display_default_background_color_label(inputs)
	if (locale === "it") return it_options_display_default_background_color_label(inputs)
	if (locale === "ru") return ru_options_display_default_background_color_label(inputs)
	if (locale === "es") return es_options_display_default_background_color_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_default_background_color_label(inputs)
	if (locale === "ja") return ja_options_display_default_background_color_label(inputs)
	if (locale === "hi") return hi_options_display_default_background_color_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_default_background_color_label(inputs)
	return en_options_display_default_background_color_label(inputs)
});